import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import { endOfDay, getUnixTime, startOfDay } from 'date-fns';

export const formatUnixDate = (date, dateFormat = 'MMM dd, yyyy') => {
  const unixDate = fromUnixTime(date);
  return format(unixDate, dateFormat);
};

export const formatDate = ({ date, todayText, yesterdayText }) => {
  const dateValue = new Date(date);
  if (isToday(dateValue)) return todayText;
  if (isYesterday(dateValue)) return yesterdayText;
  return date;
};

export const formatDigitToString = val => {
  return val > 9 ? `${val}` : `0${val}`;
};

export const isTimeAfter = (h1, m1, h2, m2) => {
  if (h1 < h2) {
    return false;
  }

  if (h1 === h2) {
    return m1 >= m2;
  }

  return true;
};

/** Get start of day as a UNIX timestamp */
export const getUnixStartOfDay = date => getUnixTime(startOfDay(date));

/** Get end of day as a UNIX timestamp */
export const getUnixEndOfDay = date => getUnixTime(endOfDay(date));

export const generateRelativeTime = (value, unit, languageCode) => {
  const code = languageCode?.replace(/_/g, '-'); // Hacky fix we need to handle it from source
  const rtf = new Intl.RelativeTimeFormat(code, {
    numeric: 'auto',
  });
  return rtf.format(value, unit);
};

/** Format a duration given in hours as "X yr Y mon Z days …" (no seconds). */
export const formatDurationFromHours = hours => {
  if (hours == null || Number.isNaN(hours)) return '—';

  let totalMinutes = Math.round(Math.abs(hours) * 60);
  if (totalMinutes === 0) return '0 min';

  const minutesPerMonth = 30 * 24 * 60;
  const minutesPerDay = 24 * 60;
  const minutesPerYear = 12 * minutesPerMonth;

  const years = Math.floor(totalMinutes / minutesPerYear);
  totalMinutes %= minutesPerYear;
  const months = Math.floor(totalMinutes / minutesPerMonth);
  totalMinutes %= minutesPerMonth;
  const days = Math.floor(totalMinutes / minutesPerDay);
  totalMinutes %= minutesPerDay;
  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  const parts = [];
  if (years) parts.push(`${years} yr`);
  if (months) parts.push(`${months} mon`);
  if (days) parts.push(`${days} day${days === 1 ? '' : 's'}`);
  if (hrs) parts.push(`${hrs} hr`);
  if (mins) parts.push(`${mins} min`);

  return parts.join(' ') || '0 min';
};
